import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      display: "flex",
    },
    list: {
      margin: 25,
      width: "85%",
    },
    items: {
      display: "flex",
      width: "90%",
      height: "100%",
      alignItems: "space-between",
      justifyContent: "center",
      flexDirection: "row",
      margin: 15,
      [theme.breakpoints.up("sm")]: {
        marginLeft: 25,
        justifyContent: "space-between",
      },
    },
    containerFilter: {
      maxWidth: "1200px",
    },
    filter: {
      display: "flex",
      gap: "4px",
      paddingBottom: "20px",
      placeSelf: "flex-start",
      "& .MuiInputBase-root": {
        width: "391px",
      },
    },
  };
});
